<rt-dropdown class="dropdown insert-dropdown" margin-bottom-small-xx>
  <ng-container #componentOutlet></ng-container>
</rt-dropdown>
